import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import PopupMenu from "components/PopupMenu";

import { ManageBillingButton } from "./components";

function PracticeMenu({ onEditPractice }) {
  const [isMenuOpen, setMenuOpen] = useState();

  return (
    <PopupMenu
      open={isMenuOpen}
      onClose={() => {
        setMenuOpen(false);
      }}
      trigger={
        <Icon
          color="grey"
          link
          style={{ float: "right" }}
          name="ellipsis horizontal"
          data-test="practice-information-menu"
          onClick={() => {
            setMenuOpen(true);
          }}
        />
      }
    >
      <React.Fragment>
        <ManageBillingButton
          onOpened={useCallback(() => {
            return setMenuOpen(false);
          }, [setMenuOpen])}
        />
        <Button
          content="Edit Practice Information"
          icon="edit"
          onClick={() => {
            onEditPractice();
            setMenuOpen(false);
          }}
        />
      </React.Fragment>
    </PopupMenu>
  );
}
PracticeMenu.propTypes = { onEditPractice: PropTypes.func };

PracticeMenu.defaultProps = { onEditPractice: () => {} };

export default PracticeMenu;
